import React from 'react';
import styles from './OfferRestriction.module.css';

interface OfferRestrictionProps {
  state: string;
}

const BubbleBottomSvg = () => (
  <svg 
    className={styles.bubbleSvg}
    xmlns="http://www.w3.org/2000/svg" 
    version="1.1" 
    viewBox="0 0 58.4 23"
  >
    <path d="M9.3,0l-5.2,12.9s0,0,0,0l-1.8,4.5h0s-.6,1.5-.6,1.5c-.6,1.5.9,3,2.4,2.4L54.3,0H9.3Z"/>
  </svg>
);

const OfferRestriction: React.FC<OfferRestrictionProps> = ({ state }) => (
  <div className={styles.container}>
    <div className={styles.bubble}>
      <h2 className={styles.bubbleTitle}>Oops!</h2>
      <p className={styles.bubbleText}>
        Looks like you&apos;re in<br />
        {state}
      </p>
      <BubbleBottomSvg />
    </div>
    <div className={styles.mainContent}>
      <h1 className={styles.mainTitle}>
        No Offers Available Here — Yet!
      </h1>
      <p className={styles.mainText}>
        Unfortunately, there aren&apos;t any offers in {state} right now due to local restrictions - but we&apos;re working on it!
      </p>
    </div>
  </div>
);

export default OfferRestriction;
